/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyNumbers } from './EmergencyNumbers';
import {
    EmergencyNumbersFromJSON,
    EmergencyNumbersFromJSONTyped,
    EmergencyNumbersToJSON,
    EmergencyNumbersToJSONTyped,
} from './EmergencyNumbers';
import type { EmergencyEmailContactOnAzure } from './EmergencyEmailContactOnAzure';
import {
    EmergencyEmailContactOnAzureFromJSON,
    EmergencyEmailContactOnAzureFromJSONTyped,
    EmergencyEmailContactOnAzureToJSON,
    EmergencyEmailContactOnAzureToJSONTyped,
} from './EmergencyEmailContactOnAzure';
import type { EmergencyContactInfoOnAzure } from './EmergencyContactInfoOnAzure';
import {
    EmergencyContactInfoOnAzureFromJSON,
    EmergencyContactInfoOnAzureFromJSONTyped,
    EmergencyContactInfoOnAzureToJSON,
    EmergencyContactInfoOnAzureToJSONTyped,
} from './EmergencyContactInfoOnAzure';

/**
 * 
 * @export
 * @interface EmergencyOnAzure
 */
export interface EmergencyOnAzure {
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    emergency_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    group_name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    group_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    incident: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyOnAzure
     */
    creation_timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    creator_auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    creator_first_name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    creator_last_name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    creator_phone_number: string;
    /**
     * 
     * @type {Array<EmergencyContactInfoOnAzure>}
     * @memberof EmergencyOnAzure
     */
    users: Array<EmergencyContactInfoOnAzure>;
    /**
     * 
     * @type {Array<EmergencyEmailContactOnAzure>}
     * @memberof EmergencyOnAzure
     */
    emergency_email_contacts: Array<EmergencyEmailContactOnAzure>;
    /**
     * 
     * @type {EmergencyNumbers}
     * @memberof EmergencyOnAzure
     */
    emergency_numbers?: EmergencyNumbers;
    /**
     * 
     * @type {number}
     * @memberof EmergencyOnAzure
     */
    resolved_timestamp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the EmergencyOnAzure interface.
 */
export function instanceOfEmergencyOnAzure(value: object): value is EmergencyOnAzure {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    if (!('incident' in value) || value['incident'] === undefined) return false;
    if (!('creation_timestamp' in value) || value['creation_timestamp'] === undefined) return false;
    if (!('creator_auth_id' in value) || value['creator_auth_id'] === undefined) return false;
    if (!('creator_first_name' in value) || value['creator_first_name'] === undefined) return false;
    if (!('creator_last_name' in value) || value['creator_last_name'] === undefined) return false;
    if (!('creator_phone_number' in value) || value['creator_phone_number'] === undefined) return false;
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('emergency_email_contacts' in value) || value['emergency_email_contacts'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function EmergencyOnAzureFromJSON(json: any): EmergencyOnAzure {
    return EmergencyOnAzureFromJSONTyped(json, false);
}

export function EmergencyOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
        'org_code': json['org_code'],
        'group_name': json['group_name'],
        'group_id': json['group_id'] == null ? undefined : json['group_id'],
        'incident': json['incident'],
        'creation_timestamp': json['creation_timestamp'],
        'creator_auth_id': json['creator_auth_id'],
        'creator_first_name': json['creator_first_name'],
        'creator_last_name': json['creator_last_name'],
        'creator_phone_number': json['creator_phone_number'],
        'users': ((json['users'] as Array<any>).map(EmergencyContactInfoOnAzureFromJSON)),
        'emergency_email_contacts': ((json['emergencyEmailContacts'] as Array<any>).map(EmergencyEmailContactOnAzureFromJSON)),
        'emergency_numbers': json['emergency_numbers'] == null ? undefined : EmergencyNumbersFromJSON(json['emergency_numbers']),
        'resolved_timestamp': json['resolved_timestamp'] == null ? undefined : json['resolved_timestamp'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function EmergencyOnAzureToJSON(json: any): EmergencyOnAzure {
    return EmergencyOnAzureToJSONTyped(json, false);
}

export function EmergencyOnAzureToJSONTyped(value?: EmergencyOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
        'org_code': value['org_code'],
        'group_name': value['group_name'],
        'group_id': value['group_id'],
        'incident': value['incident'],
        'creation_timestamp': value['creation_timestamp'],
        'creator_auth_id': value['creator_auth_id'],
        'creator_first_name': value['creator_first_name'],
        'creator_last_name': value['creator_last_name'],
        'creator_phone_number': value['creator_phone_number'],
        'users': ((value['users'] as Array<any>).map(EmergencyContactInfoOnAzureToJSON)),
        'emergencyEmailContacts': ((value['emergency_email_contacts'] as Array<any>).map(EmergencyEmailContactOnAzureToJSON)),
        'emergency_numbers': EmergencyNumbersToJSON(value['emergency_numbers']),
        'resolved_timestamp': value['resolved_timestamp'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

